import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* getLandingList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/custom_landing/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/custom_landing/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "LANDING_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_LIST_RESPONSE", value: error })
    }
}

function* addLanding(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/custom_landing/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "LANDING_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_RESPONSE", value: error })
    }
}

function* editLanding(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };
        const url = config.credentials.url + `/backoffice/custom_landing/${actions.landingId}/`

        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "LANDING_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_RESPONSE", value: error })
    }
}

function* getLanding(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/custom_landing/${actions.landingId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "LANDING_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_RESPONSE", value: error })
    }
}

function* getBannerList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_banner/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_banner/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "BANNER_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "BANNER_LIST_RESPONSE", value: error })
    }
}

function* addBanner(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_banner/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "BANNER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "BANNER_RESPONSE", value: error })
    }
}

function* editBanner(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_banner/${actions.bannerId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "BANNER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "BANNER_RESPONSE", value: error })
    }
}

function* getBanner(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_banner/${actions.bannerId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "BANNER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "BANNER_RESPONSE", value: error })
    }
}

function* editBannerScheduled(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };
        const url = config.credentials.url + `/backoffice/home_banner/${actions.bannerId}/`

        const data = yield call(apiCall, 'PATCH', url, requestOptions)

        yield put({ type: "BANNER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "BANNER_RESPONSE", value: error })
    }
}

function* uploadImageBackoffice(actions) {
    try {
        const headers = {
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: actions.data,
        };

        const url = config.credentials.url + '/backoffice/upload_images/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "UPLOAD_IMAGE_BACKOFFICE_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "UPLOAD_IMAGE_BACKOFFICE_RESPONSE", value: error })
    }
}

function* getHeaderList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/header/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/header/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "HEADER_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "HEADER_LIST_RESPONSE", value: error })
    }
}

function* addHeader(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/header/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "HEADER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "HEADER_RESPONSE", value: error })
    }
}

function* editHeader(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/header/${actions.headerId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "HEADER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "HEADER_RESPONSE", value: error })
    }
}

function* getHeader(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/header/${actions.headerId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "HEADER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "HEADER_RESPONSE", value: error })
    }
}

function* getFooterList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/footer/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/footer/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "FOOTER_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "FOOTER_LIST_RESPONSE", value: error })
    }
}

function* addFooter(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/footer/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "FOOTER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "FOOTER_RESPONSE", value: error })
    }
}

function* editFooter(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/footer/${actions.footerId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "FOOTER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "FOOTER_RESPONSE", value: error })
    }
}

function* getFooter(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/footer/${actions.footerId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "FOOTER_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "FOOTER_RESPONSE", value: error })
    }
}

function* getCommentsList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_comments/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_comments/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "COMMENTS_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COMMENTS_LIST_RESPONSE", value: error })
    }
}

function* addComments(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_comments/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "COMMENTS_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COMMENTS_RESPONSE", value: error })
    }
}

function* editComments(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_comments/${actions.commentsId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "COMMENTS_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COMMENTS_RESPONSE", value: error })
    }
}

function* getComments(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_comments/${actions.commentsId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "COMMENTS_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COMMENTS_RESPONSE", value: error })
    }
}

function* getCoveragesList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_coverage_includes/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_coverage_includes/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "COVERAGES_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COVERAGES_LIST_RESPONSE", value: error })
    }
}

function* addCoverages(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_coverage_includes/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "COVERAGES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COVERAGES_RESPONSE", value: error })
    }
}

function* editCoverages(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_coverage_includes/${actions.coveragesId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "COVERAGES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COVERAGES_RESPONSE", value: error })
    }
}

function* getCoverages(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_coverage_includes/${actions.coveragesId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "COVERAGES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "COVERAGES_RESPONSE", value: error })
    }
}

function* getServicesList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_differential_services/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_differential_services/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "SERVICES_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "SERVICES_LIST_RESPONSE", value: error })
    }
}

function* addServices(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_differential_services/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "SERVICES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "SERVICES_RESPONSE", value: error })
    }
}

function* editServices(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_differential_services/${actions.servicesId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "SERVICES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "SERVICES_RESPONSE", value: error })
    }
}

function* getServices(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_differential_services/${actions.servicesId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "SERVICES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "SERVICES_RESPONSE", value: error })
    }
}

function* getWhyChooseUsList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_why_choose_us/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_why_choose_us/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "WHY_CHOOSE_US_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "WHY_CHOOSE_US_LIST_RESPONSE", value: error })
    }
}

function* addWhyChooseUs(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_why_choose_us/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "WHY_CHOOSE_US_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "WHY_CHOOSE_US_RESPONSE", value: error })
    }
}

function* editWhyChooseUs(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_why_choose_us/${actions.whyChooseUsId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "WHY_CHOOSE_US_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "WHY_CHOOSE_US_RESPONSE", value: error })
    }
}

function* getWhyChooseUs(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_why_choose_us/${actions.whyChooseUsId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "WHY_CHOOSE_US_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "WHY_CHOOSE_US_RESPONSE", value: error })
    }
}

function* getProductNecessityList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_product_necessity/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_product_necessity/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "PRODUCT_NECESSITY_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "PRODUCT_NECESSITY_LIST_RESPONSE", value: error })
    }
}

function* addProductNecessity(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_product_necessity/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "PRODUCT_NECESSITY_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "PRODUCT_NECESSITY_RESPONSE", value: error })
    }
}

function* editProductNecessity(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_product_necessity/${actions.productNecessityId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "PRODUCT_NECESSITY_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "PRODUCT_NECESSITY_RESPONSE", value: error })
    }
}

function* getProductNecessity(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_product_necessity/${actions.productNecessityId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "PRODUCT_NECESSITY_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "PRODUCT_NECESSITY_RESPONSE", value: error })
    }
}

function* getLandingCitiesList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/home_landing_cities/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/home_landing_cities/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "LANDING_CITIES_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_CITIES_LIST_RESPONSE", value: error })
    }
}

function* addLandingCities(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/home_landing_cities/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "LANDING_CITIES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_CITIES_RESPONSE", value: error })
    }
}

function* editLandingCities(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/home_landing_cities/${actions.landingCitiesId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "LANDING_CITIES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_CITIES_RESPONSE", value: error })
    }
}

function* getLandingCities(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/home_landing_cities/${actions.landingCitiesId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "LANDING_CITIES_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "LANDING_CITIES_RESPONSE", value: error })
    }
}

function* getNotificationsList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/backoffice/notification/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/backoffice/notification/${actions.query}`

        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "NOTIFICATIONS_LIST_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "NOTIFICATIONS_LIST_RESPONSE", value: error })
    }
}

function* addNotifications(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + '/backoffice/notification/'
        const data = yield call(apiCall, 'POST', url, requestOptions)
        yield put({ type: "NOTIFICATIONS_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "NOTIFICATIONS_RESPONSE", value: error })
    }
}

function* editNotifications(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data),
        };

        const url = config.credentials.url + `/backoffice/notification/${actions.notificationId}/`
        const data = yield call(apiCall, 'PUT', url, requestOptions)
        yield put({ type: "NOTIFICATIONS_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "NOTIFICATIONS_RESPONSE", value: error })
    }
}

function* getNotifications(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = config.credentials.url + `/backoffice/notification/${actions.notificationId}`
        const data = yield call(apiCall, 'get', url, requestOptions)
        yield put({ type: "NOTIFICATIONS_RESPONSE", value: data })
    } catch (error) {
        yield put({ type: "NOTIFICATIONS_RESPONSE", value: error })
    }
}

export function* landings() {
    yield takeEvery("GET_LANDING_LIST", getLandingList);
    yield takeEvery("ADD_LANDING", addLanding);
    yield takeEvery("EDIT_LANDING", editLanding);
    yield takeEvery("GET_LANDING", getLanding);
}

export function* banners() {
    yield takeEvery("GET_BANNER_LIST", getBannerList);
    yield takeEvery("ADD_BANNER", addBanner);
    yield takeEvery("EDIT_BANNER", editBanner);
    yield takeEvery("GET_BANNER", getBanner);
    yield takeEvery("UPLOAD_IMAGE_BACKOFFICE", uploadImageBackoffice);
    yield takeEvery("EDIT_BANNER_SCHEDULED", editBannerScheduled);
}

export function* headers() {
    yield takeEvery("GET_HEADER_LIST", getHeaderList);
    yield takeEvery("ADD_HEADER", addHeader);
    yield takeEvery("EDIT_HEADER", editHeader);
    yield takeEvery("GET_HEADER", getHeader);
}

export function* footers() {
    yield takeEvery("GET_FOOTER_LIST", getFooterList);
    yield takeEvery("ADD_FOOTER", addFooter);
    yield takeEvery("EDIT_FOOTER", editFooter);
    yield takeEvery("GET_FOOTER", getFooter);
}

export function* homeComments() {
    yield takeEvery("GET_HOME_COMMENTS_LIST", getCommentsList);
    yield takeEvery("ADD_HOME_COMMENTS", addComments);
    yield takeEvery("EDIT_HOME_COMMENTS", editComments);
    yield takeEvery("GET_HOME_COMMENTS", getComments);
}

export function* homeCoverages() {
    yield takeEvery("GET_HOME_COVERAGES_LIST", getCoveragesList);
    yield takeEvery("ADD_HOME_COVERAGES", addCoverages);
    yield takeEvery("EDIT_HOME_COVERAGES", editCoverages);
    yield takeEvery("GET_HOME_COVERAGES", getCoverages);
}

export function* homeDifferentialServices() {
    yield takeEvery("GET_HOME_DIFFERENTIAL_SERVICES_LIST", getServicesList);
    yield takeEvery("ADD_HOME_DIFFERENTIAL_SERVICES", addServices);
    yield takeEvery("EDIT_HOME_DIFFERENTIAL_SERVICES", editServices);
    yield takeEvery("GET_HOME_DIFFERENTIAL_SERVICES", getServices);
}

export function* homeWhyChooseUs() {
    yield takeEvery("GET_HOME_WHY_CHOOSE_US_LIST", getWhyChooseUsList);
    yield takeEvery("ADD_HOME_WHY_CHOOSE_US", addWhyChooseUs);
    yield takeEvery("EDIT_HOME_WHY_CHOOSE_US", editWhyChooseUs);
    yield takeEvery("GET_HOME_WHY_CHOOSE_US", getWhyChooseUs);
}

export function* homeProductNecessity() {
    yield takeEvery("GET_HOME_PRODUCT_NECESSITY_LIST", getProductNecessityList);
    yield takeEvery("ADD_HOME_PRODUCT_NECESSITY", addProductNecessity);
    yield takeEvery("EDIT_HOME_PRODUCT_NECESSITY", editProductNecessity);
    yield takeEvery("GET_HOME_PRODUCT_NECESSITY", getProductNecessity);
}

export function* homeLandingCities() {
    yield takeEvery("GET_HOME_LANDING_CITIES_LIST", getLandingCitiesList);
    yield takeEvery("ADD_HOME_LANDING_CITIES", addLandingCities);
    yield takeEvery("EDIT_HOME_LANDING_CITIES", editLandingCities);
    yield takeEvery("GET_HOME_LANDING_CITIES", getLandingCities);
}

export function* notifications() {
    yield takeEvery("GET_NOTIFICATIONS_LIST", getNotificationsList);
    yield takeEvery("ADD_NOTIFICATIONS", addNotifications);
    yield takeEvery("EDIT_NOTIFICATIONS", editNotifications);
    yield takeEvery("GET_NOTIFICATIONS", getNotifications);
}
